import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { Redirect } from "react-router-dom";
import Spinner from '../common/spinner';
import QuestionnairesCombine from './QuestionnairesCombine';
import InHomeConfirmationModal from './InHomeConfirmationModal';
import { Typography, Notifier } from "../ecosystem/";
import { InHomeMainPanel, InHomeOverviewPanel, InHomeQuestionsHeading, InHomeSplitLayout } from "./layout"
import * as msgs from "../../constants/textConstants";

const InHomeEligibilityCombine = ({ history, selectedVaccines, getEligibilityQPending, getEligibilityQResult, success, getQuestionnaires, sendQuestionnaires,
    getCovidQuestionnaires, resetCovidData, screenBreakPoint }) => {

    const [questionsData, setQuestionsData] = useState(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isLastPatient, setIsLastPatient] = useState(false);
    const [inReverse, setInReverse] = useState(false);
    const [isFromCovidSurvey, setIsFromCovidSurvey] = useState(false);
    const questionnaireResponse = useRef([]);
    const removedVaccines = useRef({});

    useEffect(() => {
        //check for state data from location
        let isComingFromCovidSurvey = history?.location?.state?.fromCovidSurvey;
        if (isComingFromCovidSurvey && isComingFromCovidSurvey === true) {
            setIsFromCovidSurvey(true);
        }

    }, [])

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingEligibility.Displayed`, new Date(), Tools.getURLPath());
        getQuestionnaires();
    }, [getQuestionnaires]);

    useEffect(() => {
        if (!getEligibilityQResult) return;
        //setQuestionsData(getEligibilityQResult)
        setQuestionsData(transformData);
        setIsLastPatient(currentIndex === getEligibilityQResult.length - 1)

        //if we're coming here from covid survey, need to let the user to land on the covid eligibility questionnaire for the first user
        if (isFromCovidSurvey) {

            //check for the first index of a question having a covid eligiblity questionnaire
            let covidQIndex = getEligibilityQResult?.find(item => item.questions.find(q => q.vaccineName.toLowerCase().includes('covid')));
            //console.log("First user who has selected covid is ---> ", covidQIndex);
        }

    }, [getEligibilityQResult])


    const onPrevious = () => {
        if (currentIndex === 0) {
            history.push("/inhomeschedule/s4")
        } else {
            //setCurrentIndex(currentIndex - 1)
            let validPrevIndex = getPreviousValidIndex();
            if (validPrevIndex < 0)
                history.push("/inhomeschedule/s4")
            else {

                setCurrentIndex(validPrevIndex);
                setInReverse(true);
            }
        }
    }

    const saveResponse = (questionResponse) => {
        let temp = [...questionnaireResponse.current];
        questionnaireResponse.current = temp.concat(questionResponse);
    }

    const onNext = (questionResponse) => {

        if (currentIndex === questionsData.length - 1) {
            sendResponse(questionResponse);

            let usersWithCovidVax = selectedVaccines.filter((user) => user.vaccines_groups.find(group => group.vaccines.find(vaccines => vaccines.name.toLowerCase().includes('covid') && vaccines.isChecked)));

            if (usersWithCovidVax && usersWithCovidVax.length > 0) {

                /*
                let covGroup = usersWithCovidVax[0]?.vaccines_groups?.find(grp => grp?.group?.toLowerCase().includes('covid'));
                let covVaccine = covGroup?.vaccines?.find(vac => vac?.name?.toLowerCase().includes('covid'));
                let covidQURL = covVaccine?.questionnaire;
                console.log("covid vaccine deatils", covGroup, covVaccine, covidQURL);
                getCovidQuestionnaires(covidQURL);
                */

                resetCovidData(); //Initially, initialize the covid questionnaire, and service results data
                history.push("/inhomeschedule/s51");
            }
            else {
                history.push("/inhomeschedule/s6");
            }

        }
        else {

            if (questionResponse.length) saveResponse(questionResponse)
            if (currentIndex + 1 === questionsData.length - 1) setIsLastPatient(true);
            //setCurrentIndex(currentIndex + 1);
            setCurrentIndex(getNextValidIndex())
            setInReverse(false);
        }

    }

    const getNextValidIndex = () => {

        let nextIndex = questionsData?.findIndex((qObj, index) => qObj.skipQuestionsForUser == false && index > currentIndex);
        return nextIndex;
    }

    const getPreviousValidIndex = () => {
        let prevIndex = -1;
        for (prevIndex = currentIndex - 1; prevIndex >= 0; prevIndex--) {
            if (questionsData[prevIndex].skipQuestionsForUser == false)
                break;
        }
        //let prevIndex = questionsData?.findIndex((qObj, index) => qObj.skipQuestionsForUser == false && index < currentIndex);
        return prevIndex;
    }

    const sendResponse = (questionResponse) => {
        if (questionResponse.length) saveResponse(questionResponse);
        sendQuestionnaires(questionnaireResponse.current)
    }

    const setVaccineIsRemoved = (mrn, vaccineName) => {
        if (removedVaccines.current[mrn]) {
            removedVaccines.current[mrn].push(vaccineName)
        } else {
            removedVaccines.current[mrn] = [vaccineName];
        }
    }


    const removeQuestionsForInEligibleVaccines = (mrn, vaccineNamesArray) => {

        //When a vaccine is removed, also remove all questions for that vaccine for the specified user/mrn
        let tempQData = [...questionsData];

        vaccineNamesArray.forEach(vaxName => {

            let updatedQData = tempQData.map(qObj => {
                if (qObj.patient.mrn === mrn) {
                    let items = qObj.questions.items.filter(q => !q.includes(vaxName));
                    let skipQuestionsForUser = items?.length == 0;
                    return (
                        {
                            ...qObj,
                            // questions: { ...qObj.questions, items: [...qObj.questions.items.filter(q => !q.includes(vaxName))] },
                            //skipQuestionsForUser: qObj.questions.items?.length ==0
                            questions: { ...qObj.questions, items: items },
                            skipQuestionsForUser: skipQuestionsForUser
                        }
                    )
                }
                else
                    return ({ ...qObj })

            })

            //let cleanedQData = updatedQData.filter(qObj =>
            //    qObj.questions.items?.length > 0

            //);


            //tempQData = [...cleanedQData];
            tempQData = [...updatedQData];

        })

        setQuestionsData(tempQData);


    }

    const transformData = () => {

        let tst = getEligibilityQResult?.map((q, ind) => {
            return q.questions.map((a) => {
                return a.items.map((b) => {
                    return a.vaccineName + ":" + b
                })
            })
        });


        let flattst = tst?.map((t, i) => {
            return t.flat(1);
        })


        const transformData = getEligibilityQResult?.map((obj, i) => ({
            ...obj,
            questions: {
                items: flattst[i]
            },
            skipQuestionsForUser: false
        }))

        return transformData;

    }

    const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE || screenBreakPoint === msgs.MD_TABLET || screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.XL_DESKTOP) ? true : false;

    return (
        <>
            {(!getEligibilityQPending && getEligibilityQResult?.length < 1) || (!selectedVaccines || selectedVaccines?.length < 1) ? <Redirect to='/inhomeschedule/s4' /> :
                <>
                    <InHomeSplitLayout
                        className="inhome-eligibility-container"
                        progressPercent={5 / 7 * 100}
                    >
                        {getEligibilityQPending &&
                            <InHomeMainPanel>
                                <Spinner />
                            </InHomeMainPanel>
                        }
                        {!getEligibilityQPending && !success &&
                            <InHomeMainPanel>
                                <div className="row">
                                    <div className="col-12 col-lg-10">
                                        <Notifier colorStyle="error">Failed to load. Please try again</Notifier>
                                    </div>
                                </div>
                            </InHomeMainPanel>
                        }
                        {!getEligibilityQPending &&
                            questionsData && questionsData.map((user, index) => {
                                return index === currentIndex && <React.Fragment key={`user-${index}`}>
                                    <QuestionnairesCombine
                                        isLastPatient={isLastPatient}
                                        questions={user.questions}
                                        dictionary={user.dictionary}
                                        mrn={user.patient.mrn}
                                        onNext={onNext}
                                        onPrevious={onPrevious}
                                        history={history}
                                        inReverse={inReverse}
                                        firstName={user.patient.firstName}
                                        selectedVaccines={selectedVaccines}
                                        setVaccineIsRemoved={setVaccineIsRemoved}
                                        removedVaccines={removedVaccines.current}
                                        sendResponse={sendResponse}
                                        heading="Before you Proceed"
                                        subheading={<span>Check any of the statements below that apply to: <Typography type="body-02" bold color="$color-primary-a2">{user.patient.firstName} {user.patient.lastName} ({user.patient.dob})</Typography></span>}
                                        removeQuestionsForInEligibleVaccines={removeQuestionsForInEligibleVaccines}
                                    />
                                </React.Fragment>
                            })
                        }
                        <InHomeConfirmationModal />

                        <InHomeOverviewPanel eligibilityPhase={true} />
                    </InHomeSplitLayout>
                </>
            }
        </>
    );
}
const mapStateToProps = state => {

    return {
        selectedVaccines: state.inHome.selectedVaccines,
        getEligibilityQPending: state.inHome.getEligibilityQPending,
        getEligibilityQResult: state.inHome.getEligibilityQResult?.data || null,
        success: state.inHome.getEligibilityQResult?.success || null,
        screenBreakPoint: state.common.screenBreakPoint,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getQuestionnaires: () => {
            dispatch({ type: types.GET_INHOME_ELIGIBILITY_Q })
        },
        getCovidQuestionnaires: (covidQuestionnaireUrl) => {
            dispatch({ type: types.GET_INHOME_ELIGIBILITY_COVID_Q, covidQuestionnaireUrl })
        },
        sendQuestionnaires: (response) => {
            dispatch({ type: types.SEND_INHOME_ELIGIBILITY_RESPONSES, response })
        },
        resetCovidData: () => {
            dispatch({ type: types.RESET_COVID_DATA })
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeEligibilityCombine);